import { Box, HStack } from "@chakra-ui/react"
import { offBlack } from "../../editor/BlockStyles/ui"

export const hrGray = "rgb(204, 204, 204)"

export const Rule = ({ blockStyles }) => {
  const color =
    !blockStyles?.styleAttributes?.color ||
    blockStyles?.selectedSettings?.blockColor === "lightest"
      ? hrGray
      : blockStyles?.styleAttributes?.color

  return (
    <Box
      as="hr"
      display="flex"
      border="0"
      margin="0"
      p="15px 0"
      position="relative"
      _before={{
        borderTop: `1px solid ${color}`,
        content: "''",
        position: "absolute",
        top: "50%",
        width: "100%"
      }}
    />
  )
}

export const Dots = ({ blockStyles }) => (
  <HStack
    display="flex"
    justifyContent="center"
    alignContent="center"
    border="0"
    w="max-content"
    margin="0 auto"
    p="13px 0"
    position="relative"
    gap="1rem"
    css={{
      "& .dot": {
        fontSize: "0.5em",
        color: `${blockStyles?.styleAttributes?.color || offBlack}`,
        width: "0.5em",
        height: "0.5em",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      "& .dot::after": {
        content: '""',
        display: "block",
        width: "100%",
        height: "100%",
        borderRadius: "50%",
        backgroundColor: `${blockStyles?.styleAttributes?.color || offBlack}`
      }
    }}
  >
    <Box className="dot" />
    <Box className="dot" />
    <Box className="dot" />
  </HStack>
)

export const Spacer = () => <Box as="hr" border="0" margin="0" p="15px 0" />
